import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';

import { InvoiceCompany } from '../models/invoice-company.model';
import { InvoiceCompanyMapper } from './mappers/invoice-company.mapper';
import { GetCompaniesResponseDto } from './dtos/invoice-company.dto';

@Injectable({ providedIn: 'root' })
export class InvoiceCompaniesApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _baseUrl = `${this._env.pureSpectrum.url}/invoice/companies`;
  private readonly _mapper = new InvoiceCompanyMapper();

  public get(): Observable<InvoiceCompany[]> {
    return this._http
      .get<GetCompaniesResponseDto>(this._baseUrl)
      .pipe(
        map(({ companies }) =>
          this._mapper
            .fromDtoList(companies)
            .sort((current, next) => current.name.localeCompare(next.name)),
        ),
      );
  }
}
